import { Flex, theme } from "antd";
import {
  ModalContentButtonsContainer,
  ModalContentContainer,
  ModalContentDescription,
  ModalContentIcon,
  ModalContentIconContainer,
  ModalContentTextContainer,
  ModalContentTitle,
} from "./ModalContentStyles";

import tempIcon from "../../../../assets/images/msn3-4.png";
import { ThemeProvider } from "styled-components";
import { token } from "../../../../theme";
import MSButton from "../../../../components/MSButton/MSButton";
import { CiShare1 } from "react-icons/ci";

interface ModalContentProps {
  content: React.ReactNode;
  onActionButtonClick: () => void;
  onOtherButtonClick?: () => void;

  title?: string;
  iconType?: "info" | "success" | "error" | "warning";
  buttons?: React.ReactNode;
  buttonsType?: "ok" | "action" | "custom";
}

const ModalContent = ({
  title,
  content,
  iconType = "info",
  buttons,
  buttonsType = "ok",
  onActionButtonClick,
  onOtherButtonClick,
}: ModalContentProps) => {
  const renderButtons = () => {
    if (buttonsType === "action")
      return (
        <ModalContentButtonsContainer>
          <MSButton onClick={onActionButtonClick}>Ok</MSButton>
          <MSButton onClick={onOtherButtonClick ?? onOtherButtonClick}>
            Cancel
          </MSButton>
        </ModalContentButtonsContainer>
      );
    if (buttonsType === "custom") return buttons;
    return (
      <Flex justify="center">
        <MSButton onClick={onActionButtonClick}>OK</MSButton>
      </Flex>
    );
  };
  return (
    <ThemeProvider theme={token}>
      <Flex vertical gap={16} style={{ padding: 16 }}>
        <ModalContentContainer>
          <ModalContentIconContainer>
            <ModalContentIcon src={tempIcon} />
          </ModalContentIconContainer>
          <ModalContentTextContainer>
            <ModalContentTitle>{title || ""}</ModalContentTitle>
            <ModalContentDescription>{content}</ModalContentDescription>
          </ModalContentTextContainer>
        </ModalContentContainer>
        {renderButtons()}
      </Flex>
    </ThemeProvider>
  );
};

export default ModalContent;
